import {
  Component,
  input,
  InputSignal,
  output,
  OutputEmitterRef
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { IconComponent } from '../icon/icon.component';
import { IconButtonComponent } from '../icon-button/icon-button.component';

@Component({
  selector: 'td-wb-notification-close-button',
  templateUrl: 'notification-close-button.component.html',
  imports: [IconComponent, IconButtonComponent, TranslatePipe]
})
export class NotificationCloseButtonComponent {
  readonly ariaLabel: InputSignal<string> = input<string>('tdWb.modalHeader.CLOSE_ARIA', { 'alias': 'ariaLabel' });
  readonly close: OutputEmitterRef<void> = output<void>({ alias: 'close' });

  onCloseClick(): void {
    this.close.emit();
  }
}
